<template>
  <a-spin :spinning="formOption.busy">
    <a-form
        ref="form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
    >
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="bean名称">
            <a-input v-decorator="['beanName', rules.beanName]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="方法名称">
            <a-input v-decorator="['methodName', rules.methodName]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="参数">
            <a-input v-decorator="['params', rules.params]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item label="cron表达式">
            <a-input v-decorator="['cronExpression', rules.cronExpression]"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-col :gutter="24">
        <a-form-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 9 }">
          <div class="remark">
            <a-textarea v-decorator="['remark', rules.remark]" :autoSize="true"></a-textarea>
          </div>
        </a-form-item>
      </a-col>
    </a-form>

    <a-space class="a-form-btn-box">
      <a-button @click="endEdit('cancelled')">取消</a-button>
      <a-button type="primary" @click="_save()">提交</a-button>
      <!--      v-auth="`UPDATE`"-->
    </a-space>
  </a-spin>
</template>

<script>
import {formMixin} from "@/utils/FormMixin";
import {formatter as fmt} from "@/utils/form-formatter";
//通用代码api
import {loadBaseCodeData} from '@/services/baseCodeSource';

console.log(loadBaseCodeData)

//接口API
import {dataApi} from '@/services/client/timedTask';

/**
 * 加载规则
 */
function getRulesTemplate() {
  return {
    beanName: {
      rules: [{required: true, message: "请输入bean名称"}]
    },
    methodName: {
      rules: [{required: true, message: "请输入方法名称"}]
    },
    params: {
      rules: [{required: true, message: "请输入参数"}]
    },
    cronExpression: {
      rules: [{required: true, message: "请输入cron表达式"}]
    },
    remark: {
      rules: [{required: true, message: "请输入备注"}]
    }
  };
}


/**
 * 加载数据之后执行的函数(新建表单也会执行)
 */
function afterLoad(entity) {
  //给子表赋值
  this.editStatus = !!entity.userNo;//是否可编辑用户账号
  this.createUserId = entity.createUserId;
  this.createDate = entity.createDate;
}

/**
 * 新建表单数据 没有预设可以不写  预设的值可以在afterLoad之中调用到
 * 一般是用来写表单默认值 或者写不在表单中需要保存的值
 * @returns {Object}
 */
function newEntity() {
  return {
    isUse: true,
    isSystem: false,
    isShare: true,
    isTesting: true,
  }
}

/**
 * 加载数据
 * @param rowId 主键值
 * @returns {Promise}
 */
async function loadEntity(rowId) {
  let entity = await dataApi.getFormDetail(rowId);
  this.status = entity.data.status
  return fmt.formatFormLoad(entity, null, ['isUse']);
}


/**
 * 加载基础数据
 */
async function loadBaseData() {

}


/**
 * 提交数据
 * @param entities
 * @param vm
 * @returns {Promise}
 */
async function save(entities, vm) {
  console.log(vm)
  entities.jobId = this.rowId || '';
  entities.status = this.status
  await dataApi.saveFormDetail(entities).then(() => {
    this.$emit('saved')
  });
}


/**
 * 表单组件
 */
export default {
  mixins: [formMixin],
  components: {
    // roleTableModal
  },
  data() {
    return {
      editStatus: false,
      status:1
    }
  },
  methods: {
    loadEntity,
    newEntity,
    save,
    getRulesTemplate,
    loadBaseData,
    afterLoad,
  },
};
</script>

<style scoped lang="less">
</style>
